import React from 'react'
import case_fields from '../AddCase/case_fields.json'
import purpose_details from '../AddCase/purpose_details.json'
import { Button } from '@mui/material'
import { DownloadOutlined } from '@mui/icons-material'
import ExportToXL from '../../js/ExportToXL'

function capitalize(type) {
    if (type.length === 0) return type;
    return  type[0].toUpperCase() + type.slice(1);
}


const schemaToValues = data => {
    return data.map(d => {
        let { label, name, type = '', required, minlength, min = minlength, maxlength, max = maxlength, options = '' } = d
        if (type) {
            type = capitalize(type)
        }
        required = required == true ? 'Yes' : required == false ? 'No' : ''
        if (options) {
            options = options.map(d => d.label || d).join('\n')
        }
        return ['', label, name, type, required, min, max, options]
    })
}

const headers = ['Step', "Field label", "Field name", "Field type", "Required", "Min", "Max", "Options"]

const subHeaders = ["Step 1", "Step 2", "Step 3", "User"].map(d => {
    return [d, ...Array.from({ length: headers.length }).join(' ')]
})


export default function ExportCaseFields() {

    const onExport = () => {
        let step1 = Object.keys(case_fields).filter(d => case_fields[d].step == 1).map(d => {
            let f = case_fields[d]
            f.name = d
            if (d == 'purpose') {
                f.options = Object.keys(purpose_details)
                f.type = 'select'
            }
            return f
        })
        step1 = schemaToValues(step1)

        let step2 = []
        Object.keys(purpose_details).forEach(d => {
            step2.push({ label: "Purpose = " + d })
            step2.push({ label: "" })
            let vals = Object.values(purpose_details[d])
            step2.push(...vals)
            step2.push({ label: "" })
        })
        step2 = schemaToValues(step2)

        let step3 = Object.keys(case_fields).filter(d => case_fields[d].step == 3).map(d => {
            let f = case_fields[d]
            f.name = d
            return f
        })
        step3 = schemaToValues(step3)

        const data = [step1, step2, step3]

        ExportToXL({ headers, data, subHeaders, name: 'case-fields' })
    }

    return (
        <div className='card'>
            <div className='icon'>
                <DownloadOutlined fontSize='1em' />
            </div>
            <Button onClick={onExport}>Export Case Fields</Button>
        </div>
    )
}
